import { parseFilters } from './fetchData';
import { DOWNLOAD_FILTER_KEYS, JOB_CREATED } from '../../../components/NavigationBar/downloadConstants';
import getGeneric from '../../../actions/getGeneric';
import { showToast } from '../../../actions/Toast';


export const fetchLinkWithAppliedFilters =
  (appliedFilterValues, report_type, report_format, email) => dispatch => {

    const filteredFilters = Object.fromEntries(
      Object.entries(appliedFilterValues).filter(([key]) =>
        DOWNLOAD_FILTER_KEYS.includes(key.toLowerCase())
      )
    );
    const { filters, benchmark } = parseFilters(filteredFilters);

    

    const requestBody = {
      data_tag: 'DATATAG_DELIGHTIQ_DOWNLOAD_REPORT',
      request_data: {
        filters: {
          ...filters,
        },
        benchmark,
        exportType: report_type,
        format: report_format,
        email: email
      }
    };

    dispatch(
      getGeneric({
        requestBody,
        onSuccess: (response) => {
          const result = response?.api_response?.APITAG_DELIGHTIQ_DOWNLOAD_REPORT || {};
          if(result.data.message === JOB_CREATED)
          dispatch(showToast({ message: 'Report generation initiated. You will receive it on your email shortly.' }));
          else
          dispatch(showToast({ message: 'Report generation failed. Please try again after some time.' }));

        },
        onError: () => {
          dispatch(showToast({ message: 'Something went wrong while generating the report.Please try again after some time' }));
        }
      })
    );
  };
